import React from "react";
import { TextField } from "@mui/material";
import { NAME, PHONE_NUMBER } from "../../../helpers/maxLenghts";
import SelectComponent from "../../shared/SelectComponent";
import useMobileDetector from "../../../hooks/useMobileDetector";

const MARGIN_BOTTOM = 8;

const Second = ({ data, onChangeData, schools, hoodieFields }) => {
  const isMobile = useMobileDetector();
  const styles = {
    cardsContainer: {
      display: "flex",
      flex: 1,
      height: 100,
      flexDirection: "row",
      gap: 20,
    },
    card: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      border: "1px",
      height: 200,
      border: "1px solid transparent", // Ensure border is always present
      borderRadius: 10,
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
    },
    formContainer: {
      paddingRight: !isMobile ? 300 : 10,
      paddingLeft: !isMobile ? 300 : 10,
    },
  };

  const albumOptions = [
    {
      id: 0,
      value: 0,
      name: "Álbum chico",
    },
    {
      id: 1,
      value: 1,
      name: "Álbum grande",
    },
  ];

  const buses = [
    {
      id: 1,
      value: 1,
      name: 1,
    },
    {
      id: 2,
      value: 2,
      name: 2,
    },
    { id: 3, value: 3, name: 3 },
    { id: 4, value: 4, name: 4 },
    {
      id: 5,
      value: 5,
      name: 5,
    },
    {
      id: 6,
      value: 6,
      name: 6,
    },
    {
      id: 7,
      value: 7,
      name: 7,
    },
    {
      id: 8,
      value: 8,
      name: 8,
    },
    {
      id: 9,
      value: 9,
      name: 9,
    },
    {
      id: 10,
      value: 10,
      name: 10,
    },
    {
      id: 11,
      value: 11,
      name: 11,
    },
  ];

  const formatSchools = () => {
    const formattedSchools = [];

    for (const key in schools) {
      if (schools.hasOwnProperty(key)) {
        formattedSchools.push({
          id: key.trim(),
          value: key.trim(),
          name: key.trim(),
        });
      }
    }
    formattedSchools.sort((a, b) => a.id.localeCompare(b.id));
    return formattedSchools;
  };

  const handleChangeSchool = (val) => {
    const schoolValue = val.value;
    const busNumber = schools[schoolValue];
    onChangeData({
      ...data,
      ["Numero_Bus"]: busNumber,
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: 50,
      }}
    >
      <div style={styles.formContainer}>
        <h3 className="verticalPaddingText">Completar datos de la reserva:</h3>
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <TextField
            style={{ marginBottom: MARGIN_BOTTOM, flex: 1 }}
            value={data.Nombre_Padres}
            onChange={(e) =>
              onChangeData({ ...data, ["Nombre_Padres"]: e.target.value })
            }
            placeholder="Nombre padre/madre/tutor"
            inputProps={{
              maxLength: NAME,
              style: { textTransform: "capitalize" },
            }}
          ></TextField>
          <TextField
            style={{ marginBottom: MARGIN_BOTTOM, flex: 1 }}
            value={data.Apellido_Padres}
            onChange={(e) =>
              onChangeData({ ...data, ["Apellido_Padres"]: e.target.value })
            }
            placeholder="Apellido padre/madre/tutor"
            inputProps={{
              maxLength: NAME,
              style: { textTransform: "capitalize" },
            }}
          ></TextField>
        </div>
        <div style={{ display: "flex", flex: 1 }}>
          <TextField
            style={{ marginBottom: MARGIN_BOTTOM, flex: 1 }}
            value={data.Telefono_Padres}
            onChange={(e) =>
              onChangeData({ ...data, ["Telefono_Padres"]: e.target.value })
            }
            placeholder="Celular padre/madre/tutor"
            inputProps={{ maxLength: PHONE_NUMBER }}
          ></TextField>
        </div>
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <TextField
            style={{ marginBottom: MARGIN_BOTTOM, flex: 1 }}
            value={data.Nombre_Pasajero}
            onChange={(e) =>
              onChangeData({ ...data, ["Nombre_Pasajero"]: e.target.value })
            }
            placeholder="Nombre pasajero/a"
            inputProps={{
              maxLength: NAME,
              style: { textTransform: "capitalize" },
            }}
          ></TextField>
          <TextField
            style={{ marginBottom: MARGIN_BOTTOM, flex: 1 }}
            value={data.Apellido_Pasajero}
            onChange={(e) =>
              onChangeData({ ...data, ["Apellido_Pasajero"]: e.target.value })
            }
            placeholder="Apellido pasajero/a"
            inputProps={{
              maxLength: NAME,
              style: { textTransform: "capitalize" },
            }}
          ></TextField>
        </div>
        <div style={{ display: "flex", flex: 1 }}>
          <TextField
            style={{ marginBottom: MARGIN_BOTTOM, flex: 1 }}
            value={data.Cedula_Pasajero}
            onChange={(e) =>
              onChangeData({ ...data, ["Cedula_Pasajero"]: e.target.value })
            }
            placeholder="Cédula pasajero/a"
            inputProps={{ maxLength: PHONE_NUMBER }}
          ></TextField>
        </div>
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <SelectComponent
            onChange={(val) =>
              onChangeData({ ...data, ["Numero_Bus"]: val.name })
            }
            label={"Número de coche"}
            val={data.Numero_Bus}
            data={buses}
            filled
          ></SelectComponent>
        </div>
        {/* Campos extra solo para hoodie */}
        {hoodieFields && (
          <>
            <SelectComponent
              label="Color del buzo"
              val={data.Color_Buzo}
              onChange={(val) => onChangeData({ ...data, Color_Buzo: val.id })}
              data={[
                { id: "crema", name: "Crema" },
                { id: "negro", name: "Negro" },
              ]}
              filled
            />
            <SelectComponent
              label="Diseño espalda"
              val={data.Disenio_Espalda}
              onChange={(val) =>
                onChangeData({ ...data, Disenio_Espalda: val.id })
              }
              data={[{ id: "college", name: "College" }]}
              filled
            />
            <SelectComponent
              label="Talle"
              val={data.Talle}
              onChange={(val) => onChangeData({ ...data, Talle: val.name })}
              data={[
                { id: "S", name: "S" },
                { id: "M", name: "M" },
                { id: "L", name: "L" },
                { id: "XL", name: "XL" },
              ]}
              filled
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Second;
